import { render } from "./StyledDataBox.vue?vue&type=template&id=b36a0a3a&scoped=true"
import script from "./StyledDataBox.vue?vue&type=script&lang=js"
export * from "./StyledDataBox.vue?vue&type=script&lang=js"

import "./StyledDataBox.vue?vue&type=style&index=0&id=b36a0a3a&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b36a0a3a"]])

export default __exports__